import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {SnackBarType} from './snackbar-type.enum';

interface SnackBarData
{
    message: string;
    type: SnackBarType;
}

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
        CommonModule,
        AngularSvgIconModule
    ]
})
export class SnackBarComponent
{
    public readonly snackbarContent = inject<SnackBarData>(MAT_SNACK_BAR_DATA);

    public readonly snackBarTypes = SnackBarType;
}
